import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Base13Icon from './../../Color graphic - no background.png';
import Base13Logo from './../../Color logo - no background.png';
import EiganSpaceLogo from './../../eiganspaceLogo.png';
import CastleIcon from '@mui/icons-material/Castle';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AddLocationIcon from '@mui/icons-material/AddLocation';

import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  logo: {
    width: 165,
    height: 48,
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  eiganspaceLogo: {
    flex: 1,
    padding: 2,
    maxWidth: 100,
    resizeMode: 'contain'
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  divider: {
    margin: theme.spacing(6),
  },
  answer: {
    padding: theme.spacing(2, 2, 0),
  },
}));

export default function About() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>
      	<Container maxWidth="md" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Paper elevation={3} className={classes.paper} >
          <img className={classes.image} src={Base13Icon}/>
        </Paper>
        </Box>

        <Box style={{padding:20}}>
        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom className={classes.answer}>
          Solving your data engineering problems so you don't have to.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h6" align="left" color="textSecondary" component="p" className={classes.answer}>
          The founders of Base13 Labs have spent their combined 20+ years in the industry building custom solutions to data problems.
          They built Base13 Labs to give Data Analysts and Data Scientists back their time and energy so they can focus on driving their business' growth.
        </Typography>
        <Typography variant="h6" align="left" color="textSecondary" component="p" className={classes.answer}>
          At Base13 Labs we believe in the integrity of both our technology and in the relationships we build with our customers.
          Our goal is to provide our customers with unrivalled state-of-the-art data products to solve their ever evolving needs.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom className={classes.answer}>
          How we work
        </Typography>

        <Grid container spacing={5} alignItems="flex-start">
        <Grid item xs={12} sm={12} md={4} lg={4} >

        <Box padding={2} >
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                direction="column" display="flex" justify="center"
                >
        <AddLocationIcon style={{color:'#0284c7', width:60, height:60}} fontsize="large"/>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h5" align="left" color="textSecondary" component="p" className={classes.answer}>
          Location
        </Typography>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h6" align="left" color="textSecondary" component="p" className={classes.answer}>
          We are a fully remote team.
        </Typography>
        </Box>
        </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4}>
        <Box padding={2}>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <CastleIcon style={{color:'#0284c7', width:60, height:60}} fontsize="large"/>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h5" align="left" color="textSecondary" component="p" className={classes.answer}>
          Ownership
        </Typography>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h6" align="left" color="textSecondary" component="p" className={classes.answer}>
          Everyone has an equity stake in the company.
        </Typography>
        </Box>
        </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4}>
        <Box padding={2}>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <MeetingRoomIcon style={{color:'#0284c7', width:60, height:60}} fontsize="large"/>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h5" align="left" color="textSecondary" component="p" className={classes.answer}>
          Vacation policy
        </Typography>
        </Box>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:5}}
                >
        <Typography variant="h6" align="left" color="textSecondary" component="p" className={classes.answer}>
          Our open vacation policy allows you to decide when and how often you need a break.
        </Typography>
        </Box>
        </Box>
        </Grid>

        </Grid>

        <Divider variant="middle" className={classes.divider}/>
        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom className={classes.answer}>
          Investors
        </Typography>
        <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
                >
                  <Link href="https://eigenspace.com/" target="_blank"><img className={classes.eiganspaceLogo} src={EiganSpaceLogo}/></Link>
              </Box>
        <Divider variant="middle" className={classes.divider}/>
        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom className={classes.answer}>
          Jobs
        </Typography>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
        <Box m="auto" className={classes.button}>
          <Button size="large" href='https://www.linkedin.com/company/base13-labs/jobs/?viewAsMember=true' target="_blank" variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}} >Open Roles</Button>
        </Box>
        </Box>
        </Box>
      	</Container>
      <Footer/>
    </React.Fragment>
  );
}